export default "__VITE_ASSET__D6wC106q__"